import type { GetStaticPropsContext } from "next";

import { Container } from "@/features/common/components/Container";
import { SectionBanner } from "@/features/common/components/SectionBanner";
import { SiteLayout } from "@/features/layout/SiteLayout";
import { getRecordMap } from "@/features/notion/client";
import { NotionContent } from "@/features/notion/components/NotionContent";
import { getPublicConfig } from "@/helpers/getPublicConfig";

const FaqPage = ({ recordMap }: { recordMap: any }) => {
  return (
    <>
      <SectionBanner>常見問題</SectionBanner>
      <Container className="py-5 sm:py-10">
        <NotionContent recordMap={recordMap} pageSlug="faq" />
      </Container>
    </>
  );
};

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const { features } = getPublicConfig();
  const notionPageId = features.faq.notionPageId;

  const recordMap = await getRecordMap(notionPageId);

  return {
    props: { recordMap },
  };
};

export default FaqPage;

FaqPage.getLayout = function getLayout(page) {
  return <SiteLayout>{page}</SiteLayout>;
};
